import { render, staticRenderFns } from "./supportEnquiryList.vue?vue&type=template&id=d62e5b72&"
import script from "./supportEnquiryList.vue?vue&type=script&lang=js&"
export * from "./supportEnquiryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports